export default {"src":"/_next/static/media/team.32e8148c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};